import styled from "@emotion/styled";
import { AccountTypeStatusWrapperProps } from "src/types/account-type";


export const AccountTypeStatusWrapper = styled(
  'span',
)<AccountTypeStatusWrapperProps>(({ $color, $style }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  padding: '4px 12px',
  fontSize: '12px',
  fontWeight: 600,
  backgroundColor: `${$color}20`,
  color: $color,
  cursor: 'pointer',
  ...$style,
}));
